import { useAssetContext } from "../../contexts/AssetContext";
import CardLoader from "../CardLoader";
import AssetsDoughnutChart from "../charts/AssetsDoughnutChart";
import Container from "../Container";
import PercentageText from "../PercentageText";
import Text from "../Text";
import { useHomeContext } from "../../contexts/HomeContext";
import EmptyWallet from "../EmptyWallet";
import Card from "../Card";
        
export default function AssetWalletCard() {
    const assetContext = useAssetContext();
    const homeContext = useHomeContext();

    return (
        <Card className="justify-content-start">
            {
                assetContext.isLoading
                        ? (
                            <CardLoader />
                        )
                        : 
                        !homeContext.wallet?.totalValue
                            ? (
                                <EmptyWallet />
                            )
                            : (
                                <Container flexColumn fullWidth gap={3} className="flex-1" paddingVertical="3">
                                    <Container className="justify-content-between align-items-center">
                                        <Text color="800" fontWeight="semibold">Distribuição</Text>
                                    </Container>

                                    <Container center>
                                        <AssetsDoughnutChart />
                                    </Container>

                                    <Container className="justify-content-center flex-grow-1" flexColumn gap={3}>
                                        {
                                            assetContext.assets.map(a => {
                                                return (
                                                    <Container key={a.name} className="justify-content-between">
                                                        <Container center gap={2}>
                                                            <span className="border-round" style={{width: "10px", height: "10px", backgroundColor: a.color}}></span>
                                                            <Text color="900">{a.name}</Text>
                                                        </Container>

                                                        <Container center>
                                                            <PercentageText>{a.percentage}</PercentageText>
                                                        </Container>
                                                    </Container>
                                                )
                                            })
                                        }
                                    </Container>
                                </Container>
                        )
            }
        </Card>
    )
}